export default __webpack_public_path__ + "static/media/uisg_logo.1cdabedd.svg";